import ActivityCard from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import ContactCardContent from "./ContactActivityCardContent";

interface Props {
  activity: server.dto.ContactActivity
}

const ContactActivityRowCard = (props: Props) => {
  const { activity } = props;
  const { timestampUtc } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  return <ActivityCard
    activity={activity}
    getTitle={() => activity.action.text}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}
  >
    <ContactCardContent activity={activity} />
  </ActivityCard>;
};

export default ContactActivityRowCard;